export const NAMESPACE_STATUS = {
  requested: 'REQUESTED',
  approved: 'APPROVED',
  denied: 'DENIED',
  revoked: 'REVOKED',
  deleted: 'DELETED',
  shareable: 'SHAREABLE' // means it belongs to the cluster but the current team is able to request access
}

export const ACTION_DISPLAY_NAMES = {
  deny: 'Denied',
  approve: 'Shared',
  request: 'Requested',
  delete: 'Deleted',
  revoke: 'Revoked'
}

export const isRequested = (namespace) =>
  namespace.status === NAMESPACE_STATUS.requested
export const isDenied = (namespace) =>
  namespace.status === NAMESPACE_STATUS.denied
export const isApproved = (namespace) =>
  namespace.status === NAMESPACE_STATUS.approved
export const isRevoked = (namespace) =>
  namespace.status === NAMESPACE_STATUS.revoked
export const isDeleted = (namespace) =>
  namespace.status === NAMESPACE_STATUS.deleted
export const isShareable = (namespace) =>
  namespace.status === NAMESPACE_STATUS.shareable

export function getPendingRequests({ namespaces = [] }) {
  return namespaces.filter((namespace) => isRequested(namespace))
}

export function getApprovedRequests({ namespaces = [] }) {
  return namespaces.filter(
    (namespace) =>
      namespace.status === NAMESPACE_STATUS.approved || !namespace.status
  )
}

// approved, requested by other teams or belong to the team
export function getDisplayableNamespaces({ namespaces = [] }) {
  return namespaces.filter(
    (namespace) =>
      !namespace.status ||
      namespace.status === NAMESPACE_STATUS.approved ||
      namespace.status === NAMESPACE_STATUS.requested
  )
}

export function getNamespaceDropdownGroup(namespace) {
  if (namespace.status === NAMESPACE_STATUS.requested) {
    return 'Pending Requests'
  } else if (
    namespace.status === NAMESPACE_STATUS.approved ||
    !namespace.status
  ) {
    return 'Available'
  } else {
    return 'Shareable Namespaces'
  }
}

export function arrayToObject({
  data,
  keyFn = (item) => item,
  valueFn = (item) => item,
  hasArrayValues = false
}) {
  if (!data || data.length === 0) return {}

  let newObj = {}

  data.forEach((item) => {
    const itemKey = keyFn(item)
    const value = valueFn(item)
    if (hasArrayValues) {
      if (newObj[itemKey]) {
        newObj[itemKey].push(value)
      } else {
        newObj[itemKey] = [value]
      }
    } else {
      newObj[itemKey] = value
    }
  })

  return newObj
}

function createSearchMapTeam(team) {
  const out = [team?.identifier, team?.name].filter(Boolean)

  return out
}

export function getSearchMapTeam(data) {
  return createSearchMapTeam(data)
}

export function getRequestId({ namespace, assetId, teamId }) {
  return `${teamId}#${assetId}#${namespace}`
}

export function createRequests({
  owningTeamId,
  requestingTeamId,
  assetId,
  namespaces
}) {
  if (!namespaces || namespaces.length === 0) return []
  return namespaces.map((namespace) => ({
    owningTeamId,
    teamToShareWith: requestingTeamId,
    assetId,
    namespace
  }))
}

export function getRequestNode({ rawRequest, team, isShareable }) {
  return {
    status: isShareable ? 'SHAREABLE' : rawRequest.currentStatus,
    name: rawRequest.namespace,
    requestId: rawRequest.requestId,
    teamId: rawRequest?.sharedTeam,
    assetId: rawRequest.assetId,
    clusterName: rawRequest.assetName,
    owningTeamId: rawRequest.owningTeamId,
    team
  }
}

export function getClusterByKey({ clusters, key, value }) {
  if (!key) return {}
  return clusters.filter((cluster) => cluster[key] === value)?.[0] ?? {}
}

// BE :  Here if you own the cluster the BE sends the available clusters into
// the availableNamespaces array
// and in currentlySharedNamespaces if you don't
export function getSharedNamespacesFromCluster(clusterObject, currentTeamId) {
  return (
    clusterObject?.[
      currentTeamId === clusterObject?.owningTeamId
        ? 'availableNamespaces'
        : 'currentlySharedNamespaces'
    ] ?? []
  )
}

//////// End of BE

export function getAvailableNamespacesFromCluster(
  clusterObject,
  currentTeamId
) {
  return currentTeamId === clusterObject?.owningTeamId
    ? []
    : clusterObject?.availableNamespaces ?? []
}
